import "slick-carousel"
  ;

(function ($) {
  "use strict"
  $(function () {
    let $sliderClientsVideo = $(document).find(".x-clients-video");
    let $sliderClients = $(document).find(".x-clients-clients");
    let $sliderClientsFooter = $(document).find(".x-clients-footer");

    /*
    let player;

    function onYouTubeIframeAPIReady() {
      player = new YT.Player('ytplayer', {
        events: {
          'onReady': onPlayerReady
        }
      });
    }

    function onPlayerReady(event) {
      player.mute();
      player.playVideo();
    }
    */

    function stopVideos() {
      let elementsClick = document.getElementsByClassName('x-clients-video-item-click');

      for (let i = 0; i < elementsClick.length; i++) {
        let elements = elementsClick[i].getElementsByClassName('x-clients-video-item-player');
        let video = elements[0].getElementsByTagName("iframe")[0].contentWindow;
        video.postMessage('{"event": "command", "func": "pauseVideo", "args": ""}', "*");

        elementsClick[i].classList.remove("clients__slider-item-video-show");
      }
    }

    if ($sliderClientsVideo.length) {
      $(document).on('click', '.x-clients-video-item',
        function (e) {
          e.preventDefault()
          $(document).find('.x-clients-video-iframe').attr('src', $(this).data('video'));
          $(document).find('#clientsVideoModal').foundation('open');
        }
      )
      $(document).on('click', '.x-clients-video-item-click',
        function (e) {
          e.preventDefault()

          stopVideos();

          let video = this.getElementsByClassName('x-clients-video-item-player')[0].getElementsByTagName("iframe")[0].contentWindow;
          $(this).addClass('clients__slider-item-video-show');
          video.postMessage('{"event": "command", "func": "playVideo", "args": ""}', "*");
        }
      )

      $sliderClientsVideo.slick(
        {
          autoplay: false,
          speed: 500,
          adaptiveHeight: false,
          arrows: false,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {breakpoint: 640, settings: {slidesToShow: 1}},
          ],
        }
      )
    }

    if ($sliderClients.length) {
      $sliderClients.slick(
        {
          autoplay: true,
          speed: 500,
          adaptiveHeight: false,
          arrows: false,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {breakpoint: 640, settings: {slidesToShow: 1}},
          ],
        }
      )
    }

    if ($sliderClientsFooter.length) {
      $sliderClientsFooter.slick(
        {
          autoplay: true,
          speed: 500,
          adaptiveHeight: false,
          arrows: false,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {breakpoint: 640, settings: {slidesToShow: 1}},
          ],
        }
      )
    }

  })
})(jQuery)
